import { auth } from "lib/firebase/firebase";
import config from "config/config";

/** A full reload restores workspace initialization; anonymous sessions stay read-only. */
export function exitAudienceView(): void {
  if (!auth.currentUser || auth.currentUser.isAnonymous) return;
  window.location.replace(config.config.defaultPath);
}
